export const environment = {
  production: false,
  flavour:'dev',
  // baseUrl: 'https://api.passbookapp.in/',
  baseUrl: 'https://dev-api.passbookapp.in/',
  // baseUrl: 'http://localhost:8009/',
  // baseUrl: 'https://stage-api.passbookapp.in/',
  primaryColor: '#000',
  logoImage: '',
  companyName: '',
  entityName : '',
  bannerImage: '',
  paymentType: "",
  status: "",
  googleLink:"",
  termsAndConditions: '',
  privacyPolicy: '',
  contactUs: '',
  referralBaseUrl:'https://devpassbook-refer-earn.web.app',
  cookieStore:'',
  brandDetails: {
    "id": '',
    "name": "",
    "logo": "",
    "bannerImage": "",
    "primaryColor": "",
    "storeId": "",
    "storeName": "",
    "storeRepresentativeId": "",
    "paymentType": "",
    "status": ""
  },
  token: "",
  refreshToken: "",

  bucketName: 'passbookapp1',
  awsRegion: 'ap-south-1',
  identityPoolId: 'ap-south-1:c3601e75-54a8-46af-adba-2d6e3a95ac32',
  imageUploadSize: 1000000,
  // firebaseConfig: {
  //   apiKey: "AIzaSyCjQuQN1TwWv0DMmMTIY6VRgSv_WplLR9A",
  //   authDomain: "finshakti-ssp.firebaseapp.com",
  //   projectId: "finshakti-ssp",
  //   storageBucket: "finshakti-ssp.appspot.com",
  //   messagingSenderId: "710088896028",
  //   appId: "1:710088896028:web:e4228284f0642e2ee1f9d9",
  //   measurementId: "G-3XBV4ENER3"
  // }

//   firebaseConfig : {
//   apiKey: "AIzaSyBZ3b9B9UHkxKT7jXTfYTVqDLoxcbQrv-w",
//   authDomain: "passbook-firebase-notification.firebaseapp.com",
//   projectId: "passbook-firebase-notification",
//   storageBucket: "passbook-firebase-notification.firebasestorage.app",
//   messagingSenderId: "663672779820",
//   appId: "1:663672779820:web:427ad1f2fd4d6d56b3cd89",
//   measurementId: "G-ZHMPV9GF9R"
// },
// vapidKey : "BHxuufyRht1jWDqrORw0V16UUzxVsiFQ1ThXKkJktzZaK0-CeKgEvDMfK5QbSDUbhSYJ6DH1bK7D9Ff0yT66neM"

firebaseConfig : {
  apiKey: "AIzaSyDu0zu_X-b86iHB7pbodP63Us_190KZ_9o",
  authDomain: "dev-passbook.firebaseapp.com",
  projectId: "dev-passbook",
  storageBucket: "dev-passbook.firebasestorage.app",
  messagingSenderId: "964171497611",
  appId: "1:964171497611:web:11c91380e90852ee22948e",
  measurementId: "G-1FD7ZB0KH5"
},
vapidKey : "BHcTxVc-68qJv3s-FfEmT2C7U6EDDqrEeQf0iey2i6OxATbu2TOeWdNwe5ttYsAZrFWEIHvK-ohb8RgH2KLaqCg"
}